import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home.vue";
import IndexVideo from "../components/IndexVideo.vue";
import aboutIndex from "../components/aboutBY/index.vue";
import productCenterIndex from "../components/productCenter/index.vue";
import sbdata from "../components/productCenter/Sbdata.vue";
import newsIndex from "../components/news/index.vue";
import newsAny from "../components/news/newsAny.vue";
import indetail from "../components/news/indetail.vue";
import recruitmentIndex from "../components/talentrecruitment/index.vue";
import contactusIndex from "../components/contactus/index.vue";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/index",
    },
    {
      path: "/index",
      name: "入场",
      component: IndexVideo,
      meta: {
        title: "滨沅国科 - 绿色智慧散货港口综合管控解决方案专家",
        description: "滨沅国科专注绿色智慧散货港口全流程综合管控，提供装备自动化、协同智能化、决策智慧化、管理数字化的完整解决方案，助力港口数字化转型。",
        keywords: "绿色智慧港口,散货港口管控,港口自动化,智能港口,数字化港口,滨沅国科,港口解决方案,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/home",
      name: "首页",
      component: Home,
      meta: {
        title: "滨沅国科首页 - 绿色智慧散货港口全流程综合管控专家",
        description: "滨沅国科致力于绿色智慧散货港口建设，提供装备自动化、协同智能化、决策智慧化、管理数字化的港口综合管控解决方案，引领散货装卸数智化建设。",
        keywords: "滨沅国科,智慧港口,绿色港口,散货港口,港口自动化,智能装备,港口管控系统,数字化港口,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/aboutIndex",
      name: "关于滨沅",
      component: aboutIndex,
      meta: {
        title: "关于滨沅国科 - 智能港口科技领航者",
        description: "滨沅国科（秦皇岛）智能科技股份有限公司，专业从事智能港口技术研发，拥有丰富的港口自动化经验，致力于为全球港口提供绿色智慧解决方案。",
        keywords: "滨沅国科,公司简介,智能科技,港口技术,企业资质,技术团队,港口专家,智能化改造,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/productCenterIndex",
      name: "产品中心",
      component: productCenterIndex,
      meta: {
        title: "产品中心 - 智能港口设备与解决方案",
        description: "滨沅国科产品中心展示智能港口设备、生产系统、环保设备、安全系统等全系列产品，为港口提供完整的智能化、自动化解决方案。",
        keywords: "智能港口设备,港口自动化设备,堆取料机,装船机,翻车机,港口机械,智能控制系统,港口产品,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/sbdata",
      name: "产品详细信息",
      component: sbdata,
      meta: {
        title: "产品详情 - 智能港口设备技术参数与应用案例",
        description: "查看滨沅国科智能港口设备的详细技术参数、功能特点、应用案例，了解港口自动化设备如何提升作业效率和安全性。",
        keywords: "港口设备详情,设备技术参数,港口自动化案例,智能设备规格,港口机械性能,设备应用方案,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/newsIndex",
      name: "新闻资讯",
      component: newsIndex,
      meta: {
        title: "新闻资讯 - 港口智能化行业动态与技术前沿",
        description: "滨沅国科新闻资讯页面，提供最新的港口智能化行业动态、技术发展趋势、企业新闻和项目案例，了解智慧港口发展前沿信息。",
        keywords: "港口新闻,智能港口资讯,港口技术动态,行业新闻,港口科技,智慧港口发展,港口自动化新闻,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/newsAny",
      name: "新闻列表",
      component: newsAny,
      meta: {
        title: "新闻列表 - 港口智能化最新资讯汇总",
        description: "滨沅国科新闻列表页面，汇总港口智能化、自动化技术的最新资讯、行业动态和技术发展信息，掌握智慧港口发展脉络。",
        keywords: "港口新闻列表,智能港口动态,港口技术资讯,行业新闻汇总,港口科技发展,智慧港口资讯,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/indetail",
      name: "新闻详细",
      component: indetail,
      meta: {
        title: "新闻详情 - 港口智能化技术深度解读",
        description: "深入了解港口智能化技术的详细内容，包括技术原理、应用案例、发展趋势等，获取权威的港口科技资讯和专业解读。",
        keywords: "港口新闻详情,智能港口技术解读,港口科技深度分析,港口自动化案例,技术发展趋势,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/recruitmentIndex",
      name: "人才招聘",
      component: recruitmentIndex,
      meta: {
        title: "人才招聘 - 加入滨沅国科智能港口团队",
        description: "滨沅国科人才招聘页面，诚聘港口自动化工程师、智能控制系统专家、软件开发工程师等技术人才，共同推进智慧港口技术发展。",
        keywords: "人才招聘,港口工程师,智能控制专家,软件开发,港口技术人才,智慧港口招聘,自动化工程师,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
    {
      path: "/contactusIndex",
      name: "联系我们",
      component: contactusIndex,
      meta: {
        title: "联系我们 - 滨沅国科智能港口技术咨询服务",
        description: "联系滨沅国科获取智能港口解决方案咨询，我们提供专业的港口自动化技术支持和定制化服务，助力您的港口智能化转型。",
        keywords: "联系滨沅国科,港口技术咨询,智能港口服务,港口自动化咨询,技术支持,港口解决方案咨询,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
      },
    },
  ],
});
// SEO Meta Tag Management Function
function updateMetaTags(meta) {
  // Update page title
  if (meta.title) {
    document.title = meta.title;
  }

  // Update meta description
  if (meta.description) {
    let descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute('content', meta.description);
    } else {
      descTag = document.createElement('meta');
      descTag.setAttribute('name', 'description');
      descTag.setAttribute('content', meta.description);
      document.head.appendChild(descTag);
    }
  }

  // Update meta keywords
  if (meta.keywords) {
    let keywordsTag = document.querySelector('meta[name="keywords"]');
    if (keywordsTag) {
      keywordsTag.setAttribute('content', meta.keywords);
    } else {
      keywordsTag = document.createElement('meta');
      keywordsTag.setAttribute('name', 'keywords');
      keywordsTag.setAttribute('content', meta.keywords);
      document.head.appendChild(keywordsTag);
    }
  }

  // Update Open Graph tags
  if (meta.title) {
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', meta.title);
    }
  }

  if (meta.description) {
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', meta.description);
    }
  }

  // Update Twitter Card tags
  if (meta.title) {
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', meta.title);
    }
  }

  if (meta.description) {
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', meta.description);
    }
  }
}

router.beforeEach((to, from, next) => {
  // 获取当前时间戳
  const currentTime = new Date().getTime();
  // 获取 localStorage 中存储的过期时间
  const expirationTime = localStorage.getItem("indexExpirationTime");

  // 检查是否访问的是 index 路由，并且存在过期时间且未过期
  if (to.path === "/index" && expirationTime && currentTime < expirationTime) {
    // 重定向到其他路由，例如 SomeOtherComponent
    next({ path: "/home" });
  } else {
    // 继续正常跳转
    next();
  }

  document.documentElement.scrollTop = 0; // For modern browsers
  document.body.scrollTop = 0; // For older browsers

  // 动态更新SEO Meta标签
  const defaultMeta = {
    title: "滨沅国科（秦皇岛）智能科技股份有限公司",
    description: "滨沅国科专注绿色智慧散货港口全流程综合管控解决方案，提供装备自动化、协同智能化、决策智慧化、管理数字化的港口技术服务。",
    keywords: "绿色智慧港口,散货港口管控,港口自动化,智能港口,数字化港口,滨沅国科,堆取料机自动化,设备自动化系统,翻车机智能控制系统,卸船机智能控制系统,装船机智能控制系统,门机智能控制系统,皮带机流程智能控制系统,散货装卸设备自动化"
  };
  
  const routeMeta = { ...defaultMeta, ...to.meta };
  updateMetaTags(routeMeta);

  next();
});
export default router;
